import leaflet from 'leaflet';

export enum VectorTileGeometryType {
  Unknown = 0,
  Point = 1,
  LineString = 2,
  Polygon = 3,
}

/**
 * Style function signature used by leaflet-vector-tile-layer's vectorTileLayerStyles.
 * Called as style(feature.properties, zoom, feature.type) where type is a VectorTileGeometryType.
 */
export type VectorTileStyleFn = (
  properties: Record<string, unknown>,
  zoom: number,
  geometryType: VectorTileGeometryType
) => leaflet.PathOptions | leaflet.CircleMarkerOptions | undefined;

/**
 * This type allows to support both Vector Tile styling and GeoJSON styling
 */
export type LeafletGeometryOptions = Omit<leaflet.GeoJSONOptions, 'style'> & {
  style?: VectorTileStyleFn | leaflet.PathOptions;
};
